<template>
    <div class="card">
        <zm-popover
            placement="top"
            width="300"
            trigger="focus">
            <div>
                <div v-for="item in Object.keys(params.labels)" :key="item">{{item}}: {{params.labels[item]}}</div>
            </div>
            <zm-input size="small" v-model.trim="labelString" readonly placeholder="Labels" style="width: 120px" slot="reference">
                <zm-button type="icon" icon="zm-icon-edit" @click="showLabels()" slot="suffix"></zm-button>
            </zm-input>
        </zm-popover>
        <zm-select size="small" style="width: 220px"
            placeholder="Tags"
            v-model="params.tags"
            multiple
            :max-line="1"
            collapse-tags
            class="mutiple-select"
            allow-create
            filterable>
            <zm-option
            v-for="item in labelkeys"
            :key="item.key"
            :label="item.key"
            :value="item.key">
            </zm-option>
        </zm-select>
        <zm-button type="icon" @click="fetchData"
            class="zm-icon-search" size="small" :loading="loading"></zm-button>
        <zm-button type="icon" @click="setTopMonitor" style="float: right; margin-right: 10px;"
            class="zm-icon-upload" size="small" :loading="loading"></zm-button>
            <div style="margin-top: 5px">
                <tip v-if="metricsName.icon" :label="metricsName.tableName" :tips="metricsName.icon"></tip>
                <span v-else style="font-size: 16px;"> {{ metricsName.tableName }}</span>
            </div>
        <div id="chart" style="height: calc(50vh - 90px); margin-top: 30px">
            <!-- <span v-if="!chartData.rows.length" class="data-empty">No data</span> -->
            <ve-line :data="chartData" :extend="chartExtend" width="99%" height="calc(100% - 30px)" :settings="chartSettings"
                :legend-visible="true" :events="chartEvents" ref="chart" :legend="chartExtend.legend"></ve-line>
        </div>
        <zm-dialog title="Labels" :visible.sync="labelVisible" append-to-body width="60%">
            <zm-button size="small" @click="addParam" type="icon" icon="zm-icon-add" :disabled="addDisabled">add parameter</zm-button>
            <zm-table :data="labelList" max-height="300">
                <zm-table-column prop="key" label="Key">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.isEdit">{{ scope.row.key }}</span>
                        <zm-select size="small" v-model="scope.row.key" v-else filterable clearable allow-create style="width: 100%">
                            <zm-option v-for="item in selectableKeys" :key="item.key"
                                :disabled="!item.active" :value="item.key" :label="item.key"></zm-option>
                        </zm-select>
                    </template>
                </zm-table-column>
                <zm-table-column prop="value" label="Value">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.isEdit">{{ scope.row.value }}</span>
                        <zm-input size="small" v-model.trim="scope.row.value" v-else>
                        </zm-input>
                    </template>
                </zm-table-column>
                <zm-table-column width="120px">
                    <template slot-scope="scope">
                        <zm-button size="small" type="icon" icon="zm-icon-edit" @click="scope.row.isEdit = true" v-if="!scope.row.isEdit"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-ok" v-else
                            @click="scope.row.isEdit = false" :disabled="!scope.row.value.length || !scope.row.key.length"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-delete"
                            @click="deleteParam(scope.row.key)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="labelVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading" :disabled="addDisabled">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { getMetrics } from '@/api'
import tip from 'components/ToolTip/index'
export default {
    name: 'monitor',
    props: ['metricsName', 'timeRange', 'step', 'stepUnit', 'labelkeys', 'query', 'unit', 'timeZone'],
    components: {
        tip
    },
    data () {
        var _this = this
        return {
            loading: false,
            params: {
                endTime: 0,
                labels: {},
                tags: [],
                selectAggFunc: 'SUM',
                metricsName: '',
                startTime: 0,
                step: 1,
                stepUnit: 'h'
            },
            labelList: [],
            labelVisible: false,
            metrics: [],
            metricSelected: '',
            columns: [],
            columnSelected: '',
            totalData: null,
            chartData: {
                columns: ['time'],
                rows: []
            },
            isSelected: '',
            chartSettings: {
                yAxisName: ['']
            },
            chartEvents: {
                click: function (e) {
                    _this.chartExtend.legend.selected = {}
                    if (!_this.isSelected || (_this.isSelected && _this.isSelected !== e.seriesName)) {
                        _this.isSelected = e.seriesName
                        _this.chartExtend.legend.data.map(item => {
                            if (item === e.seriesName) {
                                _this.chartExtend.legend.selected[item] = true
                            } else {
                                _this.chartExtend.legend.selected[item] = false
                            }
                        })
                    } else {
                        _this.isSelected = ''
                        _this.chartExtend.legend.data.map(item => {
                            _this.chartExtend.legend.selected[item] = true
                        })
                    }
                },
                legendselectchanged: function (e) {
                    _this.chartExtend.legend.selected = {}
                    if (!_this.isSelected || (_this.isSelected && _this.isSelected !== e.name)) {
                        _this.isSelected = e.name
                        _this.chartExtend.legend.data.map(item => {
                            if (item === e.name) {
                                _this.chartExtend.legend.selected[item] = true
                            } else {
                                _this.chartExtend.legend.selected[item] = false
                            }
                        })
                    } else {
                        _this.isSelected = ''
                        _this.chartExtend.legend.data.map(item => {
                            _this.chartExtend.legend.selected[item] = true
                        })
                    }
                },
                legendScroll: function (e) {
                    _this.chartExtend.legend.scrollDataIndex = e.scrollDataIndex
                }
            },
            chartExtend: {
                title: {
                    show: false,
                    text: ''
                },
                // yAxis: {
                //     name: '',
                //     type: 'value'
                // },
                legend: {
                    type: 'scroll',
                    // orient: 'vertical',
                    // right: 10,
                    top: 0,
                    // bottom: 20,
                    data: [],
                    selected: {}
                },
                grid: {
                    top: 50,
                    bottom: 15,
                    containLabel: true
                },
                series: {
                    type: 'line',
                    smooth: false
                },
                tooltip: {
                    formatter: function (params) {
                        var str = params[0].axisValue
                        params.map(param => {
                            var arr = ''
                            for (var i = 0; i < param.seriesName.length / 70; i++) {
                                arr += (i >= (param.seriesName.length / 70) - 1 ? param.seriesName.slice(i * 70, (i + 1) * 70) : param.seriesName.slice(i * 70, (i + 1) * 70) + '<br />')
                            }
                            str += '<br />' + arr + ':' + param.value[1]
                        })
                        return str
                    }
                }
            }
        }
    },
    created () {
        if (this.metricsName) {
            this.params.metricsName = this.metricsName.metricsName
            this.params.selectAggFunc = this.metricsName.aggFunc
            this.columnSelected = this.metricsName.column
            this.chartExtend.title.text = this.metricsName.tableName
        }
        if (this.step) {
            this.params.step = this.step
        }
        if (this.stepUnit) {
            this.params.stepUnit = this.stepUnit
        }
        if (this.query.key) {
            this.params.labels[this.query.key] = this.query.value
            this.params.tags = [this.query.key]
            if (this.timeRange[0]) {
                this.fetchData()
            }
        }
    },
    computed: {
        selectableKeys () {
            let data = this.labelkeys
            this.labelkeys.map(key => {
                key.active = true
                this.labelList.map(item => {
                    if (key.key === item.key) {
                        key.active = false
                    }
                })
            })
            return data
        },
        addDisabled () {
            let data = false
            this.labelList.map(item => {
                if (item.isEdit) {
                    data = true
                }
            })
            return data
        },
        labelString () {
            // return JSON.stringify(this.params.labels)
            return 'Labels'
        }
    },
    watch: {
        metricsName () {
            if (this.metricsName) {
                this.params.metricsName = this.metricsName.metricsName
                this.params.selectAggFunc = this.metricsName.aggFunc
                this.columnSelected = this.metricsName.column
                this.chartExtend.title.text = this.metricsName.tableName
                this.fetchData()
            }
        },
        step () {
            this.params.step = this.step
        },
        stepUnit () {
            this.params.stepUnit = this.stepUnit
        },
        timeRange () {
            this.params.startTime = this.timeRange[0]
            this.params.endTime = this.timeRange[1]
        }
    },
    methods: {
        setTopMonitor () {
            this.$emit('setTop', this.metricsName)
        },
        showLabels () {
            this.labelList = []
            Object.keys(this.params.labels).map(item => {
                this.labelList.push({
                    key: item,
                    value: this.params.labels[item],
                    isEdit: false
                })
            })
            this.labelVisible = true
        },
        setChartData () {
            this.chartData.columns = ['time']
            this.chartData.rows = []
            this.chartExtend.legend.data = []
            this.chartExtend.legend.selected = {}
            if (this.totalData.result.length) {
                this.totalData.result[0].values.map(value => {
                    const time = new Date(value[0]).getTime() + this.timeZone * 60 * 60 * 1000
                    this.chartData.rows.push({
                        time: new Date(time).getUTCFullYear() + '-' + (new Date(time).getUTCMonth() + 1) + '-' + new Date(time).getUTCDate() + ' ' + new Date(time).getUTCHours() + ':' + new Date(time).getUTCMinutes() + ':' + new Date(time).getUTCSeconds()
                    })
                })
                this.totalData.result.map(result => {
                    result.columns.map((column, index) => {
                        if (column !== 'time') {
                            const str = column + '(' + JSON.stringify(result.metric) + ')'
                            if (this.metricSelected && !this.columnSelected) {
                                if (JSON.stringify(result.metric) === this.metricSelected) {
                                    this.chartData.columns.push(str)
                                    this.chartExtend.legend.data.push(str)
                                    this.chartExtend.legend.selected[str] = true
                                    result.values.map((value, valueIndex) => {
                                        this.chartData.rows[valueIndex][str] = value[index]
                                    })
                                }
                            } else if (this.metricSelected && this.columnSelected) {
                                if (JSON.stringify(result.metric) === this.metricSelected && column === this.columnSelected) {
                                    this.chartData.columns.push(str)
                                    this.chartExtend.legend.data.push(str)
                                    this.chartExtend.legend.selected[str] = true
                                    result.values.map((value, valueIndex) => {
                                        this.chartData.rows[valueIndex][str] = value[index]
                                    })
                                }
                            } else if (!this.metricSelected && this.columnSelected) {
                                if (column === this.columnSelected) {
                                    this.chartData.columns.push(str)
                                    this.chartExtend.legend.data.push(str)
                                    this.chartExtend.legend.selected[str] = true
                                    result.values.map((value, valueIndex) => {
                                        this.chartData.rows[valueIndex][str] = value[index]
                                    })
                                }
                            } else {
                                this.chartData.columns.push(str)
                                this.chartExtend.legend.data.push(str)
                                this.chartExtend.legend.selected[str] = true
                                result.values.map((value, valueIndex) => {
                                    this.chartData.rows[valueIndex][str] = value[index]
                                })
                            }
                        }
                    })
                })
                if (this.chartData.rows.length) {
                    this.chartSettings.yAxisName[0] = this.metricsName.unit
                }
            }
            this.$nextTick(() => {
                this.chart = this.$refs.chart.echarts
            })
            // var chart = this.$echarts.init(document.getElementById('chart'))
            // chart.setOption(this.option)
            // window.addEventListener('resize', () => {
            //     chart.resize()
            // })
        },
        fetchData () {
            this.params.startTime = this.timeRange[0]
            this.params.endTime = this.timeRange[1]
            this.metrics = []
            const { endTime, startTime, labels, metricsName, step, stepUnit, tags, selectAggFunc } = this.params
            const data = { endTime, startTime, labels, metricsName, step, stepUnit, tags, selectAggFunc }
            if (endTime && startTime && step && stepUnit) {
                this.loading = true
                getMetrics(data).then(response => {
                    this.totalData = response.data
                    if (response.data.result.length) {
                        this.columns = JSON.parse(JSON.stringify(response.data.result[0].columns))
                        this.columns.shift()
                        response.data.result.map(result => {
                            this.metrics.push(JSON.stringify(result.metric))
                        })
                    }
                    // this.chartExtend.legend.data = this.columns
                    this.setChartData()
                    this.loading = false
                    this.metricSelected = ''
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: 'Please check time range and step'
                })
            }
        },
        addParam () {
            this.labelList.unshift({
                key: '',
                value: '',
                isEdit: true
            })
        },
        deleteParam (key) {
            if (key) {
                this.labelList.map((item, index, arr) => {
                    if (item.key === key) {
                        this.labelList.splice(index, 1)
                    }
                })
            } else {
                this.labelList.shift()
            }
        },
        save () {
            this.params.labels = {}
            this.labelList.map(item => {
                this.params.labels[item.key] = item.value
            })
            this.labelVisible = false
            this.fetchData()
        },
        setTime (time) {
            var timestamp = new Date(time).valueOf() - (new Date()).getTimezoneOffset() * 60 * 1000
            return new Date(new Date(timestamp)).getUTCFullYear() + '-' + (new Date(timestamp).getUTCMonth() + 1) + '-' + new Date(timestamp).getUTCDate() + ' ' +
            new Date(timestamp).getUTCHours() + ':' + new Date(timestamp).getUTCMinutes() + ':' + new Date(timestamp).getUTCSeconds()
        },
        spliceString (string) {
            var arr = []
            for (var i = 0; i < string.length / 50; i++) {
                arr.push(i >= (string.length / 50) - 1 ? string.slice(i * 50, (i + 1) * 50) : string.slice(i * 50, (i + 1) * 50) + '/n')
            }
            return arr
        }
    }
}
</script>
<style>
.mutiple-select.zm-select .zm-select-input {
    height: 32px;
}
.mutiple-select.zm-select .zm-select-scrollbar-fix {
    height: 32px;
}
.mutiple-select.zm-select .zm-select-scrollbar-fix .zm-scrollbar__wrap {
    max-height: 50px;
    overflow-x: hidden;
}
</style>
<style scoped>
.data-empty {
    line-height: calc(50vh - 60px);
    background-color: rgba(255, 255, 255, .7);
    color: #888;
    font-size: 14px;
    margin-left: 50%;
}
.card {
    width: 90%;
    margin: 20px 0 20px 10px;
    padding: 5px 20px 0 20px;
    /* margin-bottom: 20px; */
    border-radius: 8px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    overflow: hidden;
    color: #303133;
    transition: .3s;
}
.card:hover {
    box-shadow: 0 2px 12px 0 #0E71EB;
}
</style>
